import React, { FC } from 'react'
import { Flex, Text } from '@moonpig/launchpad-components'
import { IconSystemTick } from '@moonpig/launchpad-assets'
import { spacingPx } from '@moonpig/launchpad-theme'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { ICON_TICK_SIZE, ROW_HEIGHT } from './constants'

const StyledIconTick = styled(IconSystemTick)`
  ${s({
    color: 'colorFeedbackSuccess',
    width: ICON_TICK_SIZE,
    height: ICON_TICK_SIZE,
  })}
`

const StyledMessage = styled(Flex)`
  ${s({
    alignItems: 'center',
    justifyContent: 'center',
    px: { xs: 4, md: 5, lg: 12, xl: 14 },
    py: { md: 5 },
    minHeight: `${ROW_HEIGHT}px`,
  })}
  gap: ${({ theme }) => spacingPx(3)({ theme })};
`

export const Message: FC<{ message: string }> = ({ message }) => {
  return (
    <StyledMessage>
      <StyledIconTick />
      <Text>{message}</Text>
    </StyledMessage>
  )
}
